import { modelOptions, post, prop } from "@typegoose/typegoose";
import { addSchemaKeyHook, SchemaBase, getDefaultSchemaOptions, SchemaConstructorArgs } from "../../schemaBase.js";
import { Milliseconds } from "../../../shared.js";

const SCHEMA_KEY = "Gen4ValveInternalState" as const;

export enum Gen4ValveOperationMode {
    REGULAR_IRRIGATION = 0,
    MANUAL_MODE = 1,
    THRESHOLD_AUTOMATION = 2,
    DUTY_CYCLE_AUTOMATION = 3,
}

export type ValveMode = "open" | "close";

export interface Gen4ValveScheduleBytes {
    referenceTime: Date;
    delayBytes: number[];
    permuteBytes: number[];
    startMode: ValveMode;
    startStateBit: boolean;
    includedValveEvents: Partial<{
        date: Date;
        open: boolean;
        automating: boolean;
    }>[];
    delayList: Milliseconds[];
    tickLength: Milliseconds;
    valveMode?: Gen4ValveOperationMode;
    waterHammerPreventionEnabled?: boolean;
    automationDataId?: number;
    automationOptions?: number[];
}

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<Gen4ValveInternalState>>(...addSchemaKeyHook(SCHEMA_KEY))
export class Gen4ValveInternalState extends SchemaBase<Gen4ValveInternalState> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Object, required: false })
    public schedule?: Gen4ValveScheduleBytes;

    @prop({ type: () => Number, required: false })
    public valveOperationMode?: Gen4ValveOperationMode;

    @prop({ type: () => Boolean, required: false })
    public valveOpen?: boolean;

    @prop({ type: () => Boolean, required: false })
    public defaultOpen?: boolean;

    @prop({ type: () => Boolean, required: false })
    public manualButtonNeedsAcknowledgement?: boolean;

    static getters = {} as const satisfies Record<string, (self: Gen4ValveInternalState) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<Gen4ValveInternalState>) {
        super(properties);
        Object.assign(this, properties);
    }
}
